module.exports = __webpack_public_path__ + "img/symbol_2.3b728d70.png";